import React from 'react';

import CustomSpinner, { CustomSpinnerColor } from '@components/Spinner/CustomSpinner';
import useAiAlertSubscriptions from '@hooks/useAiAlertSubscriptions';

import AiAlertSubscriptionItem from './AiAlertSubscriptionItem';
import { MAX_AI_ALERT_SUBSCRIPTIONS_COUNT } from './constants';

const AiAlertSubscriptions = (): JSX.Element => {
  const { aiAlertSubscriptions, isLoadingAiAlertSubscriptions } = useAiAlertSubscriptions();

  return (
    <div
      id="email-notifications"
      className="mt-28 border-0 border-b border-solid pb-16"
      data-testid="ai-alert-subscriptions"
    >
      <h2 className="mb-6 font-suisse-works text-headline-xxs">Email notifications</h2>
      <p className="mt-0 font-suisse-intl text-description-sm">
        You can ask us to notify you when there is new information related to your query.
      </p>
      {isLoadingAiAlertSubscriptions ? (
        <CustomSpinner
          size={10}
          color={CustomSpinnerColor.PrimaryMagenta}
          style={{ padding: '20px 0px' }}
        />
      ) : (
        <>
          <p className="pb-6 font-suisse-intl text-description-sm">
            Notification usage:{' '}
            <span className="text-primary-magenta">
              {aiAlertSubscriptions.length}/{MAX_AI_ALERT_SUBSCRIPTIONS_COUNT}
            </span>
          </p>

          {aiAlertSubscriptions.length > 0 ? (
            <ul className="list-none px-0 pt-6">
              {aiAlertSubscriptions.map((aiAlertSubscription) => (
                <AiAlertSubscriptionItem
                  key={aiAlertSubscription.id}
                  aiAlertSubscription={aiAlertSubscription}
                />
              ))}
            </ul>
          ) : (
            <div className="mb-24 text-description-sm text-grayscale-gray">No alerts yet</div>
          )}
        </>
      )}
    </div>
  );
};

export default AiAlertSubscriptions;
